import React, { useState, useEffect } from 'react';

import { Box, CircularProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import { default as ReactApexChart } from 'react-apexcharts'
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import JSONPretty from 'react-json-pretty';
import { useFormatter } from 'src/mtska-frontend-app-component/utils';

const Pie = ({ title, dataProviderName, icon, filters, handleFilterChange, mode = 'light', palette = 'palette1', monochrome = { enabled: false }, width = '100%', height = 230, showTotal = true, showName = true, showValues = true, showLegend = true, formatvalues }) => {
    const { items, loadAll, loading, reloadCounter } = useDataProvider(dataProviderName);
    const [series, setSeries] = useState();
    const [options, setOptions] = useState();
    const { t } = useTranslation();

    const { formatDate, formatCurrency } = useFormatter()

    useEffect(() => {
        if (dataProviderName && !loading) {
            loadAll(filters);
        }
    }, [reloadCounter, filters]);

    useEffect(() => {
        if (items && typeof items === 'object' && !Array.isArray(items)) {
            const total = Array.isArray(items.series)
                ? items.series.reduce((a, b) => a + b, 0)
                : 0;

            const hasData = total > 0;
            const monochromel = hasData ? monochrome : {
                enabled: true,
                color: '#CCCCCC',
                shadeTo: 'dark',
                shadeIntensity: 1
            }

            setSeries(hasData ? items.series : [1]);
            setOptions({
                labels: hasData ? items.labels : [t('Nessun dato')],
                legend: { show: showLegend },
                theme: {
                    mode: mode,
                    palette: palette,
                    monochrome: monochromel
                },
                chart: {
                    type: 'donut',
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            const clickedSliceIndex = config.dataPointIndex;
                            const clickedLabel = config.w.config.labels[clickedSliceIndex];
                            if (handleFilterChange && clickedSliceIndex < 10 && hasData) {
                                setTimeout(() => handleFilterChange(clickedLabel), 100)
                            }
                        }
                    }
                },
                responsive: [
                    {
                        breakpoint: 600,
                        options: {
                            chart: {
                                width: parseInt(width * 0.75),
                                height: parseInt(height * 0.75),
                            },
                            plotOptions: {
                                pie: {
                                    expandOnClick: false,
                                    donut: {
                                        labels: {
                                            show: true,
                                            total: {
                                                show: false,
                                            }
                                        }
                                    }
                                }
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    },
                    {
                        breakpoint: 0,
                        options: {
                            chart: {
                                width: width,
                                height: width,
                            }
                        }
                    }
                ],
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    formatter: function (val, opts) {
                        return parseFloat(val).toFixed(1) + '%'
                    },
                    textAnchor: 'middle',
                    distributed: false,
                    offsetX: 0,
                    offsetY: 0,
                    style: {
                        fontSize: '10px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'bold',
                        colors: ['#FFF'],
                        cursor: 'pointer',
                    },
                    dropShadow: {
                        enabled: false,
                    }
                },
                plotOptions: {
                    pie: {
                        expandOnClick: false,
                        donut: {
                            size: '50%',
                            labels: {
                                show: true,
                                total: {
                                    show: showTotal,
                                    fontSize: '12px',
                                    fontFamily: 'Helvetica, Arial, sans-serif',
                                    label: t('Total'),
                                    fontWeight: 200,
                                    offsetY: width == 200 ? -20 : -15,
                                    color: undefined,
                                    formatter: function () {
                                        return hasData ? total : '0';
                                    }
                                },
                                name: {
                                    show: showName,
                                    fontSize: '12px',
                                    fontFamily: 'Helvetica, Arial, sans-serif',
                                    label: t('Total'),
                                    fontWeight: 200,
                                    offsetY: width == 200 ? -20 : -15,
                                    color: undefined,
                                    formatter: function (value) {
                                        return value;
                                    }
                                },
                                value: {
                                    show: showValues,
                                    fontSize: width == 200 ? '30px' : '24px',
                                    fontFamily: 'Helvetica, Arial, sans-serif',
                                    fontWeight: 600,
                                    offsetY: -5,
                                    formatter: function (value) {
                                        return hasData ? value : '';
                                    }
                                },
                            }
                        }
                    }
                },
                tooltip: {
                    theme: 'light'
                }
            })
        }
    }, [items])


    return (
        (!series || !options) ? <CircularProgress /> :
            <Box className="mtska-chart mtska-chart-pie">
                <Icon icon={icon} family="fal"></Icon>
                <Text level="title-sm" className="title">{title}</Text>
                <Box className="chartwrapper">
                    {
                        loading ? <CircularProgress /> :

                            <ReactApexChart
                                type="donut"
                                options={options}
                                series={series}
                                height={height}
                                width={width}
                            />
                    }
                </Box>
            </Box>
    );
}

export default Pie;
//style={width == 200 ? {} : {minHeight:'40px',verticalAlign:'top',display:'block'}}